import classnames from 'classnames';
import * as React from 'react';

interface IState {
    filtersOpen: boolean;
}

export default class TableFilters extends React.Component<{ children?: React.ReactNode }, IState> {
    public state: IState = {
        filtersOpen: false,
    };

    public render = () => {
        const { filtersOpen } = this.state;

        const classes = classnames({
            'table-filters': true,
            'is-open': filtersOpen,
        });


        return (
            <div className={classnames('table-filters', classes)} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', padding: '1rem' }}>
                <div style={{ marginRight: '1rem', fontWeight: 'bold' }}>
                    <span>Filter</span>
                </div>
                <div className="filters-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {this.props.children}
                </div>
            </div>
        );
    };
}
